<!-- 编辑字段配置 -->
<template>
  <basic-container v-loading="loading">
    <div class="addTableKey">
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="110px"
        label-position="left"
        size="mini"
      >
        <el-collapse v-model="activeNames">
          <el-collapse-item title="基本参数" name="1">
            <el-row>
              <el-col :span="12">
                <el-form-item label="名称" prop="label">
                  <el-input
                    v-model="form.label"
                    placeholder="请填写名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="prop值" prop="prop">
                  <el-select
                    v-if="$route.query.tableKeyId"
                    v-model="form.prop"
                    placeholder="请选择prop值"
                    filterable
                    clearable
                    default-first-option
                  >
                    <template v-for="(item, index) in dwUnusedField">
                      <el-option
                        v-if="item.columnName == copyForm.prop"
                        :key="index"
                        :label="`${item.columnName}(当前)`"
                        :value="item.columnName"
                      >
                      </el-option>
                      <el-option
                        v-else-if="!!item.isUse"
                        :key="index"
                        :label="`${item.columnName}(已使用)`"
                        :value="item.columnName"
                        :disabled="!!item.isUse"
                      >
                      </el-option>
                      <el-option
                        v-else
                        :key="index"
                        :label="item.columnName"
                        :value="item.columnName"
                      >
                      </el-option>
                    </template>
                  </el-select>
                  <el-input v-else v-model="form.prop" placeholder="请填写prop值"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="类型" prop="type">
                  <el-select v-model="form.type" placeholder="请选择数据类型">
                    <el-option label="输入框" value="input"></el-option>
                    <el-option label="下拉框" value="select"></el-option>
                    <el-option label="密码框" value="password"></el-option>
                    <el-option label="数字框" value="number"></el-option>
                    <el-option label="滑动块" value="slider"></el-option>
                    <el-option label="颜色选择器" value="color"></el-option>
                    <el-option label="图标选择器" value="icon"></el-option>
                    <el-option label="树框" value="tree"></el-option>
                    <el-option label="单选框" value="radio"></el-option>
                    <el-option label="复选框" value="checkbox"></el-option>
                    <el-option label="开关框" value="switch"></el-option>
                    <el-option label="文本框" value="textarea"></el-option>
                    <el-option label="时间框" value="time"></el-option>
                    <el-option label="时间范围" value="timerange"></el-option>
                    <el-option label="日期框" value="date"></el-option>
                    <el-option label="日期时间框" value="datetime"></el-option>
                    <el-option label="日期时间范围" value="datetimerange" ></el-option>
                    <el-option label="多个日期" value="dates"></el-option>
                    <el-option label="月" value="month"></el-option>
                    <el-option label="周" value="week"></el-option>
                    <el-option label="年" value="year"></el-option>
                    <el-option label="超链接" value="url"></el-option>
                    <el-option label="评价框" value="rate"></el-option>
                    <el-option
                      label="弹出式单表选择器"
                      value="tableSelect"
                    ></el-option>
                    <el-option
                      label="下拉树型选择器"
                      value="treeSelect"
                    ></el-option>
                    <el-option
                      label="下拉列表选择器"
                      value="selectDown"
                    ></el-option>
                    <el-option
                      label="下拉可修改选择器"
                      value="editSelect"
                    ></el-option>
                    <el-option
                      label="强制转换大写"
                      value="toUpperCase"
                    ></el-option>
                    <el-option label="代码片段" value="code"></el-option>
                    <!-- <el-option
                      label="地理位置选择器"
                      value="mapSelect"
                    ></el-option> -->
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否返回" prop="type">
                  <el-select v-model="form.status" placeholder="请选择是否返回">
                    <el-option label="配置数据都返回" value="0"></el-option>
                    <el-option label="都不返回" value="1"></el-option>
                    <el-option label="只返回数据" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="是否隐藏">
                  <el-select v-model="form.hide" placeholder="请选择是否隐藏">
                    <el-option label="隐藏" value="true"></el-option>
                    <el-option label="显示" value="false"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否单个日期搜索">
                  <el-select v-model="form.singleDate" placeholder="请选择是否单个日期">
                    <el-option label="否" value="false"></el-option>
                    <el-option label="是" value="true"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="是否大写">
                  <el-select v-model="form.isUpper" placeholder="请选择是否大写">
                    <el-option label="是" value="true"></el-option>
                    <el-option label="否" value="false"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="从表名称">
                  <el-input
                    v-model="form.slaveTableName"
                    placeholder="请输入从表名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="从表关联键">
                  <el-input
                    v-model="form.slaveParentId"
                    placeholder="请输入从表名称"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="字段排序">
                  <el-input
                    v-model="form.listSort"
                    placeholder="请填写字段排序"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否维护">
                  <el-select
                    v-model="form.dwColType"
                    placeholder="请选择是否维护"
                  >
                    <el-option label="是" value="0"></el-option>
                    <el-option label="否" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="是否搜索">
                  <el-select v-model="form.search" placeholder="请选择是否搜索">
                    <el-option label="否" value="false"></el-option>
                    <el-option label="是" value="true"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否精确查询">
                  <el-select v-model="form.jingQue" placeholder="请选择精确查询">
                    <el-option label="否" value="false"></el-option>
                    <el-option label="是" value="true"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="对齐方式">
                  <el-select v-model="form.align" placeholder="请选择精确查询">
                    <el-option label="左对齐" value="left"></el-option>
                    <el-option label="右对齐" value="right"></el-option>
                    <el-option label="居中" value=""></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否排序控件">
                  <el-select
                    v-model="form.sortable"
                    placeholder="请选择是否排序"
                  >
                    <el-option label="否" value="false"></el-option>
                    <el-option label="是" value="true"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="宽度">
                  <el-input
                    v-model="form.width"
                    placeholder="请输入数值"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="默认值">
                  <el-input
                    v-model="form.value"
                    placeholder="请输入默认值"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="扩展属性">
                  <el-input
                    type="textarea"
                    v-model="form.extendedProp"
                    placeholder="请输入扩展属性"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col
                :span="12"
                v-show="
                  'select|tree|tableSelect|selectDown|treeSelect'.indexOf(
                    form.type
                  ) !== -1
                "
              >
                <el-form-item label="多选">
                  <el-select
                    v-model="form.multiple"
                    placeholder="请选择是否多选"
                  >
                    <el-option label="否" value="false"></el-option>
                    <el-option label="是" value="true"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col
                :span="24"
                v-show="
                  'select|tree|tableSelect|selectDown|radio|switch|input|treeSelect|code|cascader'.indexOf(
                    form.type
                  ) !== -1
                "
              >
                <el-form-item label="字典的网络请求接口" label-width="150px">
                  <el-autocomplete
                    class="inline-input"
                    v-model="form.dicUrl"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    :trigger-on-focus="false"
                    style="width: 100%"
                    @select="handleSelect"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              v-show="
                'tableSelect|selectDown|treeSelect|editSelect'.indexOf(form.type) !== -1
              "
            >
              <el-col :span="12">
                <el-form-item label="单表选择器ID">
                  <selectpage
                    v-model="form.searchslotid"
                    searchslotid="103"
                    label="选择器"
                    keyfield="ID"
                    show-field="FINDER_NAME"
                    placeholder="请选择选择器"
                    :multiple="false"
                    :selectData="{
                      selectData: [
                        { label: 'ID', prop: 'ID' },
                        { label: '表名', prop: 'TABLE_NAME',width:160 },
                        { label: '选择器名称', prop: 'FINDER_NAME', width:160},
                        { label: 'DW_ID', prop: 'DW_ID' },
                      ],
                    }"
                  >
                  </selectpage>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代码表ID">
                  <selectpage
                    v-model="form.codeTable"
                    searchslotid="119"
                    label="代码表"
                    keyfield="ID"
                    showField="CODE_DESC"
                    placeholder="请选择代码表"
                    :multiple="false"
                    :selectData="{
                      selectData: [
                        { label: 'ID', prop: 'ID' },
                        { label: '表名名称', prop: 'CODE_DESC' },
                        { label: '表名', prop: 'TABLE_NAME' },
                        { label: '是否树形', prop: 'IS_TREE' },
                      ],
                    }"
                  >
                  </selectpage>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              v-show="
                'tableSelect|selectDown|treeSelect|editSelect'.indexOf(form.type) !== -1
              "
            >
              <el-col :span="12">
                <el-form-item label="单表选择器返回key">
                  <el-select
                    v-model="form.searchslotkey"
                    placeholder="请选择选择器回填字段"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in searchslotList"
                      :label="item.columnName"
                      :value="item.columnName"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="选择器回填对应key">
                  <el-input
                    v-model="form.corField"
                    placeholder='如:{"ID":"NAME","age":"age"}'
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              v-show="
                'tableSelect|selectDown|treeSelect|editSelect'.indexOf(form.type) !== -1
              "
            >
              <el-col :span="24">
                <el-form-item label="finderWhere">
                  <el-input
                    v-model="form.finderWhere"
                    :placeholder="`如:DEPT_ID={THIS_DEPTID} AND USER_TYPE={THIS_TYPE} AND COMPANY_ID={{单位ID}}`"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="'number|textarea|slider'.indexOf(form.type) !== -1">
              <el-col :span="12">
                <el-form-item label="最小行/值">
                  <el-input
                    v-model="form.minRows"
                    type="number"
                    placeholder="请输入数值"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="最大行/值">
                  <el-input
                    v-model="form.maxRows"
                    type="number"
                    placeholder="请输入数值"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="'number'.indexOf(form.type) !== -1">
              <el-col :span="12">
                <el-form-item label="数值精度">
                  <el-input
                    v-model="form.precision"
                    placeholder="请输入数值"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              v-show="
                'date|datetime|dates|month|week|year'.indexOf(form.type) !== -1
              "
            >
              <el-col :span="12">
                <el-form-item label="真实日期格式化值">
                  <el-input
                    v-model="form.valueFormat"
                    placeholder="返回后端的时间格式"
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-s-tools"
                      @click="form.valueFormat = 'yyyy-MM-dd HH:mm:ss'"
                    ></el-button>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="显示日期格式化">
                  <el-input
                    v-model="form.format"
                    placeholder="显示值时间格式 yyyy-MM-dd HH:mm:ss"
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-s-tools"
                      @click="form.format = 'yyyy-MM-dd HH:mm:ss'"
                    ></el-button>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="关联操作其他字段"
                  prop="relatedCol"
                  label-width="160px"
                >
                  <el-input
                    v-model="form.relatedCol"
                    :placeholder="`格式是: USER_NAME:PINYIN;prop:EMPTY;DW:COMPANY`"
                    clearable
                  >
                    <el-select
                      v-model="relatedColData"
                      placeholder="请选择prop值"
                      filterable
                      default-first-option
                      @change="
                        form.relatedCol =
                          form.relatedCol === ''
                            ? `${relatedColData}:`
                            : `${form.relatedCol};${relatedColData}:`
                      "
                      slot="append"
                    >
                      <template v-for="(item, index) in dwUnusedField">
                        <el-option
                          :key="index"
                          :label="item.columnName"
                          :value="item.columnName"
                        ></el-option>
                      </template>
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="表格增删查看表单的配置" name="2">
            <el-row>
              <el-col :span="12">
                <el-form-item label="新增显示">
                  <el-select
                    v-model="form.addDisplay"
                    placeholder="请选择是否新增显示"
                  >
                    <el-option label="否" value="false"></el-option>
                    <el-option label="是" value="true"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="编辑显示">
                  <el-select
                    v-model="form.editDisplay"
                    placeholder="请选择是否编辑显示"
                  >
                    <el-option label="否" value="false"></el-option>
                    <el-option label="是" value="true"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="新增禁止">
                  <el-select
                    v-model="form.addDisabled"
                    placeholder="请选择是否新增禁止"
                  >
                    <el-option label="否" value="false"></el-option>
                    <el-option label="是" value="true"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="编辑禁止">
                  <el-select
                    v-model="form.editDisabled"
                    placeholder="请选择是否编辑禁止"
                  >
                    <el-option label="否" value="false"></el-option>
                    <el-option label="是" value="true"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="是否必填">
                  <el-select
                    v-model="form.rules[0].required"
                    placeholder="请选择是否必填"
                  >
                    <el-option label="否" value="false"></el-option>
                    <el-option label="是" value="true"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="必填提示信息">
                  <el-input
                    v-model="form.rules[0].message"
                    placeholder="请填写必填提示信息"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="12">
                <el-form-item label="必填验证方式">
                  <el-select
                    v-model="form.rules[0].trigger"
                    placeholder="请选择验证方式"
                  >
                    <el-option label="失焦触发" value="blur"></el-option>
                    <el-option label="改变触发" value="change"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row>
              <el-col :span="12">
                <el-form-item label="正则表达式">
                  <el-input
                    v-model="form.rules[1].pattern"
                    placeholder="请输入正则表达式/^1[34578]\d{9}$/"
                    clearable
                  >
                    <el-select
                      v-model="ruleData"
                      filterable
                      default-first-option
                      @change="form.rules[1].pattern = ruleData"
                      slot="append"
                    >
                      <template v-for="(item, index) in ruleArr">
                        <el-option
                          :key="index"
                          :label="item.key"
                          :value="item.value"
                        ></el-option>
                      </template>
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="正则提示信息">
                  <el-input
                    v-model="form.rules[1].message"
                    placeholder="请填写必填提示信息"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="正则验证方式">
                  <el-select
                    v-model="form.rules[1].trigger"
                    placeholder="请选择验证方式"
                  >
                    <el-option label="失焦触发" value="blur"></el-option>
                    <el-option label="改变触发" value="change"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="表单栅列">
                  <el-input
                    v-model="form.span"
                    type="number"
                    placeholder="请输入数值"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="表单文字宽度">
                  <el-select
                    v-model="form.formLabelWidth"
                    placeholder="请选择字数"
                  >
                    <el-option label="0个字" value="0"></el-option>
                    <el-option label="3个字" value="62"></el-option>
                    <el-option label="4个字" value="80"></el-option>
                    <el-option label="5个字" value="95"></el-option>
                    <el-option label="6个字" value="110"></el-option>
                    <el-option label="7个字" value="123"></el-option>
                    <el-option label="8个字" value="137"></el-option>
                    <el-option label="9个字" value="155"></el-option>
                    <el-option label="10个字" value="170"></el-option>
                    <el-option label="11个字" value="184"></el-option>
                    <el-option label="12个字" value="198"></el-option>
                    <el-option label="13个字" value="212"></el-option>
                    <el-option label="14个字" value="226"></el-option>
                    <el-option label="15个字" value="240"></el-option>
                    <el-option label="16个字" value="254"></el-option>
                    <el-option label="17个字" value="268"></el-option>
                  </el-select>
                  <el-input
                    v-model="form.formLabelWidth"
                    placeholder="请输入宽度px"
                  ><template slot="append">px</template></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="灰色提示信息">
                  <el-input
                    v-model="form.placeholder"
                    placeholder="请输入输入框占位文本"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="触摸提示文本维护">
                  <el-input
                    type="textarea"
                    v-model="form.tip"
                    placeholder="请输入提示文本"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="注释">
                  <el-input
                    v-model="form.notes"
                    placeholder="请输入注释"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="注释柵列">
                  <el-input
                    v-model="form.notesSpan"
                    placeholder="请输入注释柵列"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否开启提示富文本" label-width="150px">
                  <el-switch
                    v-model="form.defaultHelp"
                    active-value="1"
                    inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-button v-if="form.defaultHelp==1" type="primary" size="mini" @click="propClick()">去维护提示富文本<i class="el-icon-arrow-right el-icon--right"></i></el-button>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="动态链接的配置" name="3">
            <el-row>
              <el-col :span="12">
                <el-form-item label="链接类型">
                  <el-select
                    v-model="form.linkType"
                    placeholder="请选择链接类型"
                  >
                    <el-option label="不链接" :value="0"></el-option>
                    <el-option label="列表链接" :value="1"></el-option>
                    <el-option label="详情链接" :value="2"></el-option>
                    <el-option label="列表详情链接" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="链接功能ID">
                  <el-input
                    v-model="form.linkOpid"
                    type="number"
                    placeholder="请输入链接功能ID"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="链接方式">
                  <el-select
                    v-model="form.linkMethod"
                    placeholder="请选择链接方式"
                  >
                    <el-option label="详情" value="1"></el-option>
                    <el-option label="列表" value="2"></el-option>
                    <el-option label="外部" value="9"></el-option>
                    <el-option label="链接事件" value="10"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="链接路径">
                  <el-input
                    v-model="form.linkPath"
                    placeholder="请输入链接路径如:　/document/handle"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="链接参数">
                  <el-input
                    v-model="form.linkParam"
                    placeholder="如：name=收文阅办&recId={id}&docType=1"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
        <el-form-item>
          <el-row>
            <el-col :span="8"></el-col>
            <el-col :span="8">
              <el-button type="primary" size="mini" @click="onSubmit">{{
                title
              }}</el-button>
              <el-button size="mini" @click="cancel">取消</el-button>
            </el-col>
            <el-col :span="8"></el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
  </basic-container>
</template>
<script>
import {
  addKeyList,
  seeKey,
  updateKeyList,
  getDwUnusedField,
  getDictUrl,
} from "@/api/table/table";
import Selectpage from "@/components/table/template/Selectpage"; // 下拉选择器
import {diffObject} from "@/util/util"; // 下拉选择器
export default {
  components: {
    Selectpage,
  },
  data() {
    return {
      title: "增加",
      funLoading: false,
      dwUnusedField: [], //prop值的对象数组
      dictUrl: [], //获取字典的网络请求接口
      dicUrlModel: "", //用来保存dicUrl
      copyForm: {}, //detail值，只用来对照不改变
      id: "", //表id
      loading: false,
      drawer: false, //弹框
      activeNames: ["1"],
      // 表单内容
      form: {
        singleDate:"",
        slaveParentId: "",//从表关联键
        slaveTableName: "",//从表名称
        jingQue: "",//是否精确查询
        align:"",//对齐方式
        isUpper: "",//是否大写
        status: "", //  是否返回
        listSort: "", // 字段排序
        finderWhere: "", // filterWhere
        searchslotkey: "",
        searchslotid: "",
        codeTable: "", // 代码表ID
        corField: "",
        dwColType: "0", // 是否维护
        addDisabled: "", // 新增禁止
        editDisabled: "", // 修改禁止
        relatedCol: "", // 自动转换大写配置字段
        extendedProp: "", // 扩展配置
        dwId: "",
        label: "",
        prop: "",
        type: "input",
        dicUrl: "",
        value: "", // 默认值
        span: "", // 表单宽度
        formLabelWidth: "", // 表单label宽度
        notes: "", // 注释文字
        notesSpan: "", // 注释栅栏
        width: "", // 表格宽度
        search: "", // 是否搜索
        addDisplay: "", // 新增显示
        editDisplay: "", // 修改显示
        maxRows: "", // 最大值
        minRows: "", // 最小值
        multiple: "", // 是否多选
        precision: "", // 数值精度 小数点
        format: "", // 日期显示格式
        valueFormat: "", // 日期传入后端格式
        sortable: "", // 是否后端排序
        linkType: "", // 链接类型
        linkOpid: "", // 链接功能id
        linkMethod: "", // 链接方式
        linkPath: "", // 链接路径
        linkParam: "", // 链接参数
        rules: [
          // 验证
          {
            required: "", //必填
            message: "",
            // trigger: "",
          },
          {
            pattern: "", //可以写正则表达式呦呦呦
            message: "",
            trigger: "",
          },
        ],
      },
      rules: {
        label: [{ required: true, message: "请输入名称" }],
        prop: [{ required: true, message: "请输入prop值" }],
        type: [{ required: true, message: "请选择类型" }],
        status: [
          { required: true, message: "请选择是否返回" },
        ],
      },
      ruleArr: [
        {
          key: "数字",
          value: "/^[0-9]*$/",
        },
        {
          key: "零和非零开头的数字",
          value: "/^(0|[1-9][0-9]*)$/",
        },
        {
          key: "非零开头的最多带两位小数的数字",
          value: "/^([1-9][0-9]*)+(.[0-9]{1,2})?$/",
        },
        {
          key: "汉字",
          value: "/^[\\u4e00-\\u9fa5]{0,}$/",
        },
        {
          key: "英文和数字",
          value: "/^[A-Za-z0-9]+$/",
        },
        {
          key: "Email地址",
          value: "/^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/",
        },
        {
          key: "网址",
          value: "/^http://([\\w-]+\\.)+[\\w-]+(/[\\w-./?%&=]*)?$/",
        },
        {
          key: "手机号",
          value:
            "/^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])d{8}$/",
        },
        {
          key: "身份证号码",
          value: "/^\\d{8,18}|[0-9x]{8,18}|[0-9X]{8,18}?$/",
        },
        {
          key: "密码(以字母开头，长度在6~18之间，只能包含字母、数字和下划线)",
          value: "/^[a-zA-Z]\\w{5,17}$/",
        },
        {
          key: "腾讯QQ号",
          value: "/[1-9][0-9]{4,}/",
        },
        {
          key: "中国邮政编码",
          value: "/[1-9]\\d{5}(?!\\d)/",
        },
      ],
    };
  },
  computed: {},
  watch: {
    "form.span": function (curVal, oldVal) {
      if (!curVal) {
        this.form.span = "";
        return false;
      }
      // 实时把非数字的输入过滤掉
      this.form.span = curVal.match(/\d/gi)
        ? curVal.match(/\d/gi).join("")
        : "";
    },
    "form.width": function (curVal, oldVal) {
      if (!curVal) {
        this.form.width = "";
        return false;
      }
      // 实时把非数字的输入过滤掉
      this.form.width = curVal.match(/\d/gi)
        ? curVal.match(/\d/gi).join("")
        : "";
    },
    "form.maxRows": function (curVal, oldVal) {
      if (!curVal) {
        this.form.maxRows = "";
        return false;
      }
      // 实时把非数字的输入过滤掉
      this.form.maxRows = curVal.match(/\d/gi)
        ? curVal.match(/\d/gi).join("")
        : "";
    },
    "form.precision": function (curVal, oldVal) {
      if (!curVal) {
        this.form.precision = "";
        return false;
      }
      // 实时把非数字的输入过滤掉
      this.form.precision = curVal.match(/\d/gi)
        ? curVal.match(/\d/gi).join("")
        : "";
    },
    "form.searchslotid": function (curVal, oldVal) {
      this.searchslotListFn();
    },
  },
  methods: {
    // 点击 prop
    propClick() {
      console.log(this.form);
      this.$router.push({
        path: "/table/tipEdit",
        query: {
          runId:this.$route.query.runId,
          name:"维护提示富文本",
          colId: this.form.id,
          colName:this.form.prop,
          dwId:this.form.dwId
        }
      });
    },
    async querySearch(queryString, cb) {
      await this.dicUrlFocus();
      var dictUrl = this.dictUrl;
      var results = queryString
        ? dictUrl.filter(this.createFilter(queryString))
        : dictUrl;
      results = results.map((item) => {
        return { value: item };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (results) => {
        return results.toLowerCase().indexOf(queryString.toLowerCase()) != -1;
      };
      // return
    },
    loadAll() {
      this.dicUrlFocus();
    },
    handleSelect(item) {
      console.log(item);
    },
    // 清空form
    emptyForm() {
      let form = this.form;
      for (let key in form) {
        form[key] = "";
      }
      (form.rules = [
        {
          required: "", //必填
          message: "",
          // trigger: "",
        },
        {
          pattern: "", //可以写正则表达式呦呦呦
          message: "",
          // trigger: "",
        },
      ]),
        (this.form = form);
    },
    // 点击提交
    onSubmit() {
      this.$refs.form.validate((valid) => {
        let form = this.deepClone(this.form);
        if(form.corField){
          try {
            JSON.parse(form.corField);
          } catch (error) {
            this.$message.error("选择器回填对应key不是JSON格式!");
            return false;
          }
        }
        if (valid) {
          this.loading = true;
          form.rules = JSON.stringify(form.rules);
          if (this.$route.query.tableKeyId) {
            let obj= diffObject(form,this.copyForm);
            if(Object.keys(obj).length>0){
              updateKeyList(this.$qs.stringify({...obj,id:this.copyForm.id})).then(
                () => {
                  this.$message.success("操作成功!");
                  this.cancel();
                },
                (err) => {
                  this.loading = false;
                }
              );
            }else{
              this.$message.success("操作成功!");
              this.cancel();
            }
          } else {
            addKeyList(this.$qs.stringify(form)).then(
              () => {
                this.loading = false;
                this.$message.success("操作成功!");
                this.cancel();
              },
              (err) => {
                this.loading = false;
              }
            );
          }
        } else {
          this.$message.error("您输入有误哦!");
          return false;
        }
      });
    },
    //获取dicurl数据
    async dicUrlFocus() {
      if (this.dictUrl.length == 0) {
        try {
          this.funLoading = true;
          let getDictUrlRes = await getDictUrl();
          this.dictUrl = new Set([
            ...(this.form.dicUrl ? [this.form.dicUrl] : []),
            ...[...getDictUrlRes.data.data],
          ]); //去重并赋值
          this.dictUrl = [...this.dictUrl];
          this.funLoading = false;
        } catch (e) {
          console.log(e);
        }
      }
    },
    searchslotListFn() {
      if (this.form.searchslotid) {
        getDwUnusedField({ finderId: this.form.searchslotid }).then(
          (res) => {
            this.searchslotList = res.data.data.columnList;
            if (!this.$route.query.tableKeyId) {
              this.form.searchslotkey = "ID";
            }
          },
          (err) => {}
        );
      }
    },
    //当选择不同的dicurl时
    onDicUrl(val) {
      if (val) this.form.dicUrl = val;
    },
    // 点击取消
    cancel() {
      this.$store.commit("DEL_TAG", { value: this.$route.fullPath });
      this.$router.go(-1); //返回上一层
      this.copyForm={};
    },
  },
  created() {},
  mounted() {},
  async activated() {
    this.id = this.$route.query.id;
    if (this.$route.query.tableKeyId) {
      this.title = "修改";
      this.loading = true;
      seeKey(this.$route.query.tableKeyId).then(
        (res) => {
          let form = res.data.data;
          form.status = form.status.toString();
          form.linkType = Number(form.linkType);
          this.copyForm = this.deepClone(form);
          form.rules = JSON.parse(form.rules);
          this.form = form;
          this.dicUrlModel = this.form.dicUrl; //再下拉上展示已有的数据
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        }
      );
    } else {
      this.title = "新增";
      console.log(this.$refs.form);
      this.emptyForm();
    }
    this.form.dwId = this.id;
    let [dwUnusedField] = await Promise.all([
      getDwUnusedField({
        dwId: this.id,
        capital: "",
      }),
    ]);
    this.dwUnusedField = dwUnusedField.data.data.columnList;
  },
};
</script>
<style lang='scss' scoped>
.el-drawer {
  overflow: auto;
}
/deep/ .el-col {
  padding: 0 10px;
  box-sizing: border-box;
}
/deep/ .el-form-item--mini.el-form-item {
  margin-bottom: 5px;
}
/deep/ .el-dropdown {
  width: 100%;
}
</style>
